import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ClearSearch } from "@insite/client-framework/Store/Pages/OrderApprovalList/Handlers/ClearSearch";
import clearDirtyFilters from "@store/Store/Pages/OrderApprovalList/Handlers/ClearDirtyFilters";

addToChainAfter(chain, ClearSearch, props => {
    props.dispatch(clearDirtyFilters());
});
